import { useEffect, useState } from 'react';

import { Grid } from '@mui/material';
import PronologyLogo from './Icons/pronology-logo.png';
import StorageOrRecordCalculations from './components/StorageOrRecordDurationCalculator';
import StyledAppBar from './components/UI/StyledAppBar';
import SpeedCalculator from './components/SpeedCalculator';
import DivisionLine from './components/UI/DivisionLine';
import { getStorageResultFromLocalStorage, getStorageUnitsFromLocalStorage } from './Utils/LocalStorageHelper';
import AvailableStorageUnits from './components/AvailableOptions/AvailableStorageUnits';

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [storageResult, setStorageResult] = useState(getStorageResultFromLocalStorage(0));
  const [storageUnits, setStorageUnits] = useState(getStorageUnitsFromLocalStorage(AvailableStorageUnits[2]));
  const WidthToMobile = 900;

  useEffect(() => {
    if (window.innerWidth < WidthToMobile) {
      setIsMobile(true);
    }

    function handleResize() {
      if (window.innerWidth < WidthToMobile && !isMobile) {
        setIsMobile(true);
      } else if (window.innerWidth >= WidthToMobile && isMobile) {
        setIsMobile(false);
      }
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile]);

  return (
    <div style={{ maxWidth: '800px', backgroundColor: '#404040', margin: 'auto' }}>
      <Grid container>
        <Grid item xs={12}>
          <StyledAppBar title="Calculator" align="left" logo={PronologyLogo} />
        </Grid>
      </Grid>
      <StorageOrRecordCalculations
        isMobile={isMobile}
        storageResult={storageResult}
        setStorageResult={setStorageResult}
        storageUnits={storageUnits}
        setStorageUnits={setStorageUnits}
      />
      <DivisionLine color="white" />
      <SpeedCalculator storageResult={storageResult} storageUnits={storageUnits} />
    </div>
  );
}
export default App;
